import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/notifications/notification.service";
import { PermissionService } from "src/app/permission.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { SignalsService, TemplateDTO } from "src/app/signals/signals.service";
import { UiService } from "src/app/ui/ui.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-template-library",
  templateUrl: "./template-library.component.html",
  styleUrls: ["./template-library.component.scss"],
})
export class TemplateLibraryComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");

  columns = [
    { code: "type", name: "Type" },
    { code: "layout", name: "Layout" },
    { code: "name", name: "Name", filter: true, selected: true },
    { code: "header_image", name: "Header Image" },
    { code: "background_image", name: "Background Image" },
    {
      code: "created_at",
      name: "Created By",
    },
    {
      code: "options",
    },
  ];
  displayedColumns = this.columns.map((column) => column.code);
  sortColumns = this.columns.filter((column) => column.filter);
  perPage: number = 20;

  @ViewChild("templateTable") templateTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  templates!: TemplateDTO[];
  showDelete: boolean = false;
  showView: boolean = false;
  showCreateAndEdit: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  templateElementLoader!: ElementLoaderDirective;
  templateDataSource!: TemplatesDataSource;
  onFilterColumnChange = new Subject();

  constructor(
    private route: ActivatedRoute,
    private SessionService: SessionService,
    private router: Router,
    private Dialog: MatDialog,
    private SignalsService: SignalsService,
    private NotificationService: NotificationService,
    private PermissionService: PermissionService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.templateDataSource.filterPredicate = (data: any, filter: string) => {
    //   for (let selectedColumn of this.selectedColumns) {
    //     if (data[selectedColumn]?.toString().toLowerCase().includes(filter)) {
    //       return true;
    //     }
    //   }
    //   return false;
    // };

    this.perPage = this.localStorageSvc.pageSize || 20;

    Promise.all([
      this.PermissionService.categories.templates.hasDetail(),
      this.PermissionService.categories.templates.hasWrite(),
      this.PermissionService.categories.templates.hasDelete(),
    ]).then(([hasDetail, hasWrite, hasDelete]) => {
      this.showDelete = hasDelete;
      this.showView = hasDetail;
      this.showCreateAndEdit = hasWrite;
    });
  }

  ngAfterViewInit() {
    // this.templateTable?.renderRows();
    // this.templateDataSource.sort = this.sort;
    // this.templateDataSource.paginator = this.paginator;

    this.templateDataSource = new TemplatesDataSource(
      this.SignalsService,
      this.paginator,
      this.templateElementLoader,
    );

    this.loadTemplatesPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadTemplatesPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  loadTemplatesPage() {
    const sort = this.buildSort();

    return this.templateDataSource.loadTemplates(
      this.SessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  // reinitTemplates() {
  //   this.uiService
  //     .waitForEvent(
  //       this.SignalsService.getSignalTemplates(this.currentAccount.accountID, {
  //         page: 0,
  //         perPage: 999999999,
  //       }),
  //     )
  //     .pipe(takeUntil(this.onComponentDestroy))
  //     .subscribe((templates) => {
  //       this.templates = (templates as any).records.map(
  //         (template: TemplateDTO) => {
  //           return {
  //             ...template,
  //             header_image: template.logo?.name,
  //             background_image: template.background?.name,
  //           };
  //         },
  //       );
  //       this.templateDataSource = new MatTableDataSource(this.templates);
  //       this.templateDataSource.paginator = this.paginator;
  //       this.templateDataSource.sort = this.sort;

  //       this.templateTable.renderRows();
  //     });
  // }

  createNewTemplate() {
    this.router.navigate(["create"], { relativeTo: this.route.parent });
  }

  // applyFilter() {
  //   this.templateDataSource.filter = this.searchValue.trim().toLowerCase();
  // }

  viewTemplate(template: TemplateDTO) {
    this.router.navigate(["view/" + template.id], {
      relativeTo: this.route.parent,
    });
  }

  editTemplate(template: TemplateDTO) {
    this.router.navigate(["edit/" + template.id], {
      relativeTo: this.route.parent,
    });
  }

  deleteTemplate(template: TemplateDTO) {
    this.Dialog.open(AreYouSureDialogComponent, {
      data: {
        areYouSureInfo: {
          description: `This template will be permanantly deleted`,
        },
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        if (res) {
          this.uiService
            .waitForEvent(
              this.SignalsService.deleteSignalTemplate(
                this.currentAccount.accountID,
                template.id!,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Template deleted",
                );
                this.loadTemplatesPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting template",
                );
              },
            );
        }
      });
  }

  toggleFilterDialog() {
    this.Dialog.open(FilterTableDialogComponent, {
      data: {
        columns: this.columns,
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }

}

export class TemplatesDataSource implements DataSource<any> {
  private templatesSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private SignalsService: SignalsService,
    private paginator: MatPaginator,
    private templatesElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.templatesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.templatesSubject.complete();
  }

  loadTemplates(masterAccountID: number, queryParams: any) {
    return this.templatesElementLoader
      .waitForEvent(
        this.SignalsService.getSignalTemplates(
          masterAccountID,
          queryParams,
        ).pipe(catchError(() => of({ count: 0, records: [] }))),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records.map((record: any) => {
            return {
              ...record,
              header_image: record.logo?.name,
              background_image: record.background?.name,
            };
          });
          this.templatesSubject.next(records);
        }),
      );
  }
}
